export const pricingRowsPerPage = [10, 20, 50, 100];

export const STATUS_COLUMN = 'status';
export const CHANNELS_COLUMN = 'channels';
export const IMAGE_COLUMN = 'image';
export const MODEL_COLUMN = 'model';
export const RETAIL_PRICE_COLUMN = 'retail';
export const UNIT_PRICE_COLUMN = 'unit';
export const SALE_PRICE_COLUMN = 'sale';
export const MSRP_PRICE_COLUMN = 'msrp';

export const PRICING_VARIANT_IDENTIFIERS = ['sku', 'upc', 'ean'];

export const ALL_PRICE_TYPES = ['retail', 'unit', 'sale'];

export const RETAILER_PRODUCTS_CURRENCY_LEVELS = {
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional',
};

export const WHOLESALE_PRICE_KEY = 'wholesale_price';
export const RETAIL_PRICE_KEY = 'retail_price';
